var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-page',[_c('com-order-search',{on:{"search":_vm.handleSearch,"onExport":_vm.handleExport}}),_c('com-card',[_c('com-order-list',{ref:"orderListRef",attrs:{"api":_vm.api,"defaultParams":_vm.defaultParams}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }